// extracted by mini-css-extract-plugin
export var headerCell = "_58-1";
export var loadingSpinnerContainer = "_58-4";
export var rowWrapper = "_58-3";
export var standaloneTable = "_58-5";
export var table = "_58-0";
export var white = "_58-2";